import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Modal from 'react-modal'; // Add this import
import { FiPlay, FiX } from 'react-icons/fi'; // Add this import

const Gallery = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    // Mock videos data
    setVideos([
      {
        id: 1,
        title: "Kenyan Diaspora Speaks Out",
        thumbnail_path: "/placeholder-thumbnail.jpg",
        uploader_name: "John D."
      },
      {
        id: 2,
        title: "Our Demand for Change",
        thumbnail_path: "/placeholder-thumbnail.jpg",
        uploader_name: "Mary K."
      }
    ]);
    setLoading(false);
  }, []);

  const openModal = (video) => {
    setSelectedVideo(video);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedVideo(null);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-kenya-red"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Helmet>
        <title>Gallery | Kenyans in Diaspora Petition</title>
      </Helmet>
      
      <h1 className="text-3xl font-bold text-center text-kenya-black mb-8">Our Voices from the Diaspora</h1>
      
      {videos.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-xl">No videos available yet. Check back soon!</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map(video => (
            <div 
              key={video.id} 
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow"
            >
              <div 
                className="relative cursor-pointer group" 
                onClick={() => openModal(video)}
              >
                <img 
                  src={video.thumbnail_path || '/placeholder-thumbnail.jpg'} 
                  alt={video.title}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <FiPlay className="text-white text-4xl" />
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-lg mb-1">{video.title}</h3>
                {video.uploader_name && (
                  <p className="text-gray-600 text-sm">By {video.uploader_name}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      
      {/* Video Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="modal-overlay"
      >
        {selectedVideo && (
          <div className="relative">
            <button 
              onClick={closeModal}
              className="absolute -top-10 right-0 text-white hover:text-gray-300"
            >
              <FiX size={24} />
            </button>
            <div className="aspect-w-16 aspect-h-9">
              <video 
                controls 
                autoPlay 
                className="w-full"
                poster={selectedVideo.thumbnail_path}
              >
                <source src={selectedVideo.file_path} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            <div className="bg-white p-4">
              <h3 className="text-xl font-bold">{selectedVideo.title}</h3>
              {selectedVideo.description && (
                <p className="mt-2">{selectedVideo.description}</p>
              )}
            </div>
          </div>
        )}
      </Modal>
      
      <style jsx global>{`
        .modal {
          position: absolute;
          top: 50%;
          left: 50%;
          right: auto;
          bottom: auto;
          margin-right: -50%;
          transform: translate(-50%, -50%);
          width: 80%;
          max-width: 800px;
          outline: none;
        }
        
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.75);
          z-index: 1000;
        }
      `}</style>
    </div>
  );
};

export default Gallery;